import {IWish} from "../wish/Helper";
import WishlistService from "../../api/wishlistService";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {toastError} from "../../component/shared/toast/Toast";

export const getWishlist = createAsyncThunk<IWish[]>(`${SliceNames.WISHLIST}/getWishlist`,
    async (_, thunkAPI) => {
        try {
            const res = await WishlistService.fetchWishlist()
            return res.data
        } catch (e) {
            return thunkAPI.rejectWithValue(e)
        }
    })

export const addToWishlist = createAsyncThunk<IWish, IWish>(`${SliceNames.WISHLIST}/addToWishlist`,
    async (wish, thunkAPI) => {
        try {
            await WishlistService.addToWishlist(wish.id)
            return wish
        } catch (e: any) {
            toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
            return thunkAPI.rejectWithValue(e)
        }
    })

export const removeFromWishlist = createAsyncThunk<string, IWish>(`${SliceNames.WISHLIST}/removeFromWishlist`,
    async (wish, thunkAPI) => {
        try {
            await WishlistService.removeFromWishlist(wish.id)
            return wish.id
        } catch (e: any) {
            toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
            return thunkAPI.rejectWithValue(e)
        }
    })